import logger from '../helpers/logger/logger';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sendAnalytics = (data: any) => {
  logger.logInfo('send data layer to analytics', JSON.stringify(data));

  global.dataLayer = global.dataLayer || [];

  return global.dataLayer.push({ ...data });
};
